const dataSlider = [
  {
    id: 1,
    title: 'Hi, I am under washing.',
    image_link: '../imgs/img1.jpg',
  },
  {
    id: 2,
    title: 'Hi, I am under grooming.',
    image_link: '../imgs/img2.jpg',
  },
  {
    id: 3,
    title: 'Hi, I like keeping clean and tidy.',
    image_link: '../imgs/img3.jpg',
  },
  {
    id: 4,
    title: 'Hi, welcome to the DIY grooming.',
    image_link: '../imgs/img4.jpg',
  },
];

export default dataSlider;
